export default __webpack_public_path__ + "static/media/salem.bf508361.jpg";